import React, { useEffect, useState } from 'react'
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Flatpickr from "react-flatpickr";
import { Common } from 'helpers/common';
import { saveAnnouncement as onAddAnnouncementList} from '../../helpers/backend_helper';
import "flatpickr/dist/flatpickr.css";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'; import { Loader2, X } from 'lucide-react';
import Drawer from 'Common/Components/Drawer';
import moment from 'moment';
import { useAuth } from 'hooks/useStore';

type Props = { onHide: () => void; show: boolean, data: any, onSave: (result: any) => void }

const AddAnnouncement: React.FC<Props> = ({ onHide, show, data, onSave }) => {

    const [announcementData, setAnnouncementData] = useState<any>(data);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [userId, setUserId] = useState<any>(0);
    const { user } = useAuth();

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [editorDataEnglish, setEditorDataEnglish] = useState('<br/><br/>');
    const [editorDataSpanish, setEditorDataSpanish] = useState('<br/><br/>');
    const commonHelper = new Common();

    useEffect(() => {
        console.log(announcementData);

        if (announcementData?.announcementId) {
            setIsEdit(announcementData?.announcementId > 0);
            setEditorDataEnglish(announcementData?.bodyEnglish);
            setEditorDataSpanish(announcementData?.bodySpanish);
            console.log(announcementData);
        }

        setUserId(user?.userId ?? 1);
    }, [])

    // validation
    const validation: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: (announcementData && announcementData.title) || '',
            shortDescription: (announcementData && announcementData.shortDescription) || '',
            bodyEnglish: (announcementData && announcementData.bodyEnglish) || '',
            bodySpanish: (announcementData && announcementData.bodySpanish) || '',
            startDate: (announcementData && moment(announcementData.startDate)).format('MM/DD/yyyy') || null,
            endDate: (announcementData && moment(announcementData.endDate)).format('MM/DD/yyyy') || null,
            isActive: (announcementData && announcementData.isActive) || true,
            createdById: (announcementData && announcementData.createdById) || userId,
            announcementId: (announcementData && announcementData.announcementId) || 0,
            announcementTypeId: (announcementData && announcementData.announcementTypeId) || 1,
        },
        validationSchema: Yup.object({
            title: Yup.string().required("Please Enter Title !"),
            shortDescription: Yup.string().required("Please Enter Short Desciption !"),
            bodyEnglish: Yup.string().required("Please Enter English Description !"),
            bodySpanish: Yup.string().required("Please Enter Spanish Description !"),
            startDate: Yup.date().required("Please Enter Start Date !"),
            endDate: Yup.date().required("Please Enter End Date !"),
            isActive: Yup.bool().required("Please choose yes or no!"),
            announcementTypeId: Yup.number().required("Please select announcement type!")
        }),

        onSubmit: async (values: any) => {
            setIsSaving(true);

            try {
                const newData = {
                    ...values,
                    startDate: moment(values.startDate).format('YYYY-MM-DD'),
                    endDate: moment(values.endDate).format('YYYY-MM-DD')
                };
                var result = await onAddAnnouncementList(newData);
                commonHelper.showSuccessMessage('Announcement has been successfully saved.');
                onSave(result.data);
            } catch (error) {
                console.log('API-Error', error);
                commonHelper.showErrorMessage(error as string);
                setIsSaving(false);
            }

            setIsSaving(false);
        },
    });

    const handleStartDateChange = (selectedDates: any, dateStr: any, instance: any) => {
        console.log(dateStr)
        validation.setFieldValue('startDate', dateStr)
    }

    const handleEndDateChange = (selectedDates: any, dateStr: any, instance: any) => {
        validation.setFieldValue('endDate', dateStr)
    }

    const onEnglishEditorChange = (event: any, editor: any) => {
        validation.setFieldValue('bodyEnglish', editor.getData())
    };


    const onSpanishEditorChange = (event: any, editor: any) => {
        validation.setFieldValue('bodySpanish', editor.getData())
    };

    const handleDrawer = () => { onHide(); }

    return (
        <React.Fragment>

            <Drawer show={show} onHide={handleDrawer} id="cartSidePenal" drawer-end="true" className="fixed inset-y-0 flex flex-col  
      transition-transform duration-600 ease-in-out transform bg-white shadow 
     dark:bg-zink-600 ltr:right-0 rtl:left-0  w-5/6 flex  z-drawer">
                <div className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500">
                    <div className="grow">
                        <h5 className="mb-0 text-16">{isEdit ? "Update" : "New"} Announcement </h5>
                    </div>
                    <div className="shrink-0">
                        <div className="flex items-center justify-end gap-[200px]">
                            <div className="flex items-center gap-2 group">

                            </div>
                            <Drawer.Header data-drawer-close="cartSidePenal" className="transition-all duration-150 ease-linear text-slate-500 hover:text-slate-800">
                                <X className="size-4"></X>
                            </Drawer.Header>
                        </div>
                    </div>
                </div>
                <Drawer.Body className="h-full p-0 overflow-y-auto">
                    <div className="h-full overflow-y-auto product-list">
                        <form action="#!" onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}>
                            <div className="grid grid-cols-1 gap-5 xl:grid-cols-12 m-4">
                                <div className="lg:col-span-2 xl:col-span-12">
                                    <label htmlFor="title" className="inline-block mb-2 text-base font-medium">Title</label>
                                    <input type="text" className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                        id="title"
                                        name="title"
                                        placeholder="Title"

                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.title || ""} />
                                    {validation.touched.title && validation.errors.title ? (
                                        <div id="title-error" className="mt-1 text-sm text-red-500">{validation.errors.title}</div>
                                    ) : null}
                                </div>

                         

                                <div className="lg:col-span-2 xl:col-span-12">
                                    <h6 className="mb-4 text-15">Short Description</h6>
                                    <div className="ckeditor-classic text-slate-800">
                                        <textarea
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"

                                            id="shortDescription"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.shortDescription || ""}
                                        />
                                        {validation.touched.shortDescription && validation.errors.shortDescription ? (
                                            <div id="shortDescription-error" className="mt-1 text-sm text-red-500">{validation.errors.shortDescription}</div>
                                        ) : null}
                                    </div>
                                </div>
       <div className="lg:col-span-2 xl:col-span-4">
                                    <label htmlFor="startDate" className="inline-block mb-2 text-base font-medium">Start Date</label>
                                    {(Flatpickr as any)({
                                        id: "startDate",
                                        options: {
                                            altInput: true,
                                            altFormat: "m/d/Y",
                                            dateFormat: "m/d/Y",
                                        },
                                        onChange: handleStartDateChange,
                                        onBlur: validation.handleBlur,
                                        value: validation.values.startDate || "",
                                        placeholder: "Select Date",
                                        className: "form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    })}



                                    {/* <input
                                        type="date"
                                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                        id="startDate"
                                        name="startDate"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.startDate || ""}
                                    /> */}

                                    {validation.touched.startDate && validation.errors.startDate ? (
                                        <div id="startDate-error" className="mt-1 text-sm text-red-500">{validation.errors.startDate}</div>
                                    ) : null}
                                </div>

                                <div className="lg:col-span-2 xl:col-span-4">
                                    <label htmlFor="endDate" className="inline-block mb-2 text-base font-medium">End Date</label>
                                    {(Flatpickr as any)({
                                        id: "endDate",
                                        options: {
                                            altInput: true,
                                            altFormat: "m/d/Y",
                                            dateFormat: "m/d/Y",
                                        },
                                        onChange: handleEndDateChange,
                                        onBlur: validation.handleBlur,
                                        value: validation.values.endDate || "",
                                        placeholder: "Select Date",
                                        className: "form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                    })}

                                    {validation.touched.endDate && validation.errors.endDate ? (
                                        <div id="endDate-error" className="mt-1 text-sm text-red-500">{validation.errors.endDate}</div>
                                    ) : null}
                                </div>

                                <div className="lg:col-span-2 xl:col-span-4">
                                    <label htmlFor="announcementTypeId" className="inline-block mb-2 text-base font-medium">Announcement Type</label>
                                    <select
                                        id="announcementTypeId"
                                        name="announcementTypeId"
                                        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.announcementTypeId || ""}
                                    >
                                        <option value={1}>Important</option>
                                        <option value={2}>Event</option>
                                        <option value={3}>Emergency</option>
                                    </select>
                                    {validation.touched.announcementTypeId && validation.errors.announcementTypeId ? (
                                        <div id="announcementTypeId-error" className="mt-1 text-sm text-red-500">{validation.errors.announcementTypeId}</div>
                                    ) : null}
                                </div>

                               


                                <div className="lg:col-span-2 xl:col-span-12">
                                    <h6 className="mb-4 text-15">English Description</h6>
                                    <div className="ckeditor-classic text-slate-800">
                                        <CKEditor
                                            id="bodyEnglish"
                                            editor={ClassicEditor}
                                            onChange={onEnglishEditorChange}
                                            data={editorDataEnglish}
                                        />
                                        {validation.touched.bodyEnglish && validation.errors.bodyEnglish ? (
                                            <div id="bodyEnglish-error" className="mt-1 text-sm text-red-500">{validation.errors.bodyEnglish}</div>
                                        ) : null}
                                    </div>
                                </div>

                                <div className="lg:col-span-2 xl:col-span-12">
                                    <h6 className="mb-4 text-15">Spanish Description</h6>
                                    <div className="ckeditor-classic text-slate-800">
                                        <CKEditor
                                            id="bodySpanish"
                                            editor={ClassicEditor}
                                            onChange={onSpanishEditorChange}
                                            data={editorDataSpanish}
                                        />
                                        {validation.touched.bodySpanish && validation.errors.bodySpanish ? (
                                            <div id="bodySpanish-error" className="mt-1 text-sm text-red-500">{validation.errors.bodySpanish}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-end gap-2 mt-4">
                                <button type="reset" data-modal-close="addDocuments" className="text-red-500 transition-all duration-200 ease-linear bg-white border-white btn hover:text-red-600 focus:text-red-600 active:text-red-600 dark:bg-zink-500 dark:border-zink-500" onClick={onHide}>Cancel</button>

                                {!isSaving ?
                                    <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                        {"Save Announcement" }
                                    </button>
                                    : <button type="button" disabled className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                        <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                                        Saving...
                                    </button>
                                }

                            </div>
                        </form>
                    </div>
                </Drawer.Body>


            </Drawer>


        </React.Fragment>
    )
}

export default AddAnnouncement;